import * as e from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/Eyeglasses.es.js";
const s = e.forwardRef((o, a) => /* @__PURE__ */ e.createElement(r, { ref: a, ...o, weights: t }));
s.displayName = "EyeglassesIcon";
const n = s;
export {
  n as Eyeglasses,
  s as EyeglassesIcon
};
